// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"267": "c6a753b4","393": "5e650f25",}[chunkId] + ".css"
}